module.exports = __webpack_public_path__ + "img/pantalla-2-6.06caa40a.png";